import request from "@/utils/request"
// 消息列表
export function fetchGetNoticeList(data) {
  return request({
    method: "POST",
    url: "/bseos_interface/noticeList",
    data,
  })
}
